import * as React from 'react';
import { Text } from 'wix-ui-tpa/Text';
import s from './OfferingDetails.st.css';
import {
  RunningEnvironmentProps,
  withRunningEnvironmentContext,
} from '../../context/running-environment-context';

interface OfferingDetailsProps extends RunningEnvironmentProps {
  ellipsis?: boolean;
  children?;
}

const OfferingDetailsComponent = ({
  runningEnvironment,
  ellipsis = false,
  children,
  ...rest
}: OfferingDetailsProps) => {
  const { isMobile } = runningEnvironment;
  return (
    <div className={s.detailsWrapper}>
      <Text
        typography="listText"
        tabIndex={-1}
        {...s('root', { disableFontSize: isMobile, isMobile, ellipsis }, rest)}
        tagName="p"
      >
        {children}
      </Text>
    </div>
  );
};

export const OfferingDetails = withRunningEnvironmentContext(
  OfferingDetailsComponent,
);
